import React, { Component } from "react";

export default class Step3 extends Component {
  constructor() {
    super();
    this.state = {};
  }

  toggleStepStatus = state => {
    switch (state) {
      case 0:
        return "step-disabled";
      case 1:
        return "step--current";
      case 2:
        return "step--completed";
      default:
        return;
    }
  };

  render() {
    let stepStatus = this.toggleStepStatus(this.props.appBarState3);
    let activateModal;
    if (this.props.appBarState3 === 2)
      activateModal = this.props.modalTypeSelectorToggle;
    if (this.props.showTypeSelectorModal) stepStatus = "step--edit";
    return (
      <div className="section-steps__step" onClick={activateModal}>
        <div className={`step ${stepStatus}`}>
          <div className="step__number">3</div>
          <div className="step__name">
          {this.props.distanceSelected ? (
              <div>
                <p>{this.props.distanceSelected}</p>
              </div>
            ) : (
              "DATOS DE TU LEXUS"
            )}</div>
          <div className="step__edit">
            <img src="./images/ico_edit.png" alt="editPen" />
          </div>
        </div>
      </div>
    );
  }
}
